import type { SVGProps } from "react";

export default function TaskChecksIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M1.6665 4.58333L2.67841 5.83333L6.24984 2.5"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.6665 10.4166L2.67841 11.6666L6.24984 8.33325"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.6665 16.2501L2.67841 17.5001L6.24984 14.1667"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3324 15.833H9.99902"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M18.3324 10.0002H9.99902"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M18.3324 4.16675H9.99902"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
